export const scapholdURL = "https://eu-west-1.api.scaphold.io/graphql/codogo";
export const scapholdAuthTokenStorageKey = "CodogoScapholdAuth";
export const accountURL = "https://account.codogo.io";
